export default __webpack_public_path__ + "static/media/ic-user.ff32f4ea.svg";